import { createSlice } from '@reduxjs/toolkit';



const initialState = {
  answers: [] 
};

const quizSlice = createSlice({
  name: 'quiz',
  initialState,
  reducers: {
    
  },
});

export const {  } = quizSlice.actions;

export default quizSlice.reducer;